


































import { RealworksStatusRule } from '@/api/model/realworks-status-rule'
import { Component, Inject, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CreatePhaseStatusVerticalStep1 extends Vue {
    @Prop({ required: true }) readonly currentStep!: number
    @Prop({ default: false }) readonly existing!: boolean
    @Prop({ required: true }) readonly value!: RealworksStatusRule
    @Inject() kenmerkLabel: (kenmerkId) => string

    get triggerType(): string {
        if (this.value.triggerType === 'agendaTypes') {
            return 'Afspraak'
        } else if (this.value.triggerType === 'taakTypes') {
            return 'Taak'
        } else {
            return 'Kenmerk'
        }
    }

    get assignTypes(): string[] {
        if (this.value.triggerType === 'agendaTypes') {
            return this.value.agendaTypes
        } else if (this.value.triggerType === 'taakTypes') {
            return this.value.taakTypes
        } else {
            if (this.value.kenmerken.length === 0) {
                return ['-']
            }

            return this.value.kenmerken.map(kenmerkId => this.kenmerkLabel(kenmerkId))
        }
    }

    get statusType() {
        if (this.value.triggerType === 'agendaTypes') {
            return this.value.agendaStatus
        } else if (this.value.triggerType === 'taakTypes') {
            return this.value.taakStatus
        } else {
            return null
        }
    }

    get supportsAssignToMedewerker(): boolean {
        return this.value.triggerType === 'agendaTypes'
    }

    get assignToString(): string {
        if (this.value.assignToMedewerker === true) {
            return 'Ja'
        } else {
            return 'Nee'
        }
    }
}
